































import Vue from 'vue'
import { mdiCookie, mdiFileDocumentOutline } from '@mdi/js'
import { ROUTES } from '@/enums'
import { Location } from 'vue-router'

export default Vue.extend({
    name: 'TheFooter',

    data: () => ({ mdiCookie, mdiFileDocumentOutline }),

    computed: {
        year(): string {
            return new Date().getFullYear().toString()
        },

        routePolicyCookies(): Location {
            return { name: ROUTES.POLICY_COOKIES }
        },

        routePolicyPrivacy(): Location {
            return { name: ROUTES.POLICY_COOKIES }
        },
    },
})
